import { FeaturesConfig } from "../FeaturesProvider";
import { ErrorSeverity, ErrorCode } from "~/modules/error";
import { throwAndReportFlexSdkError } from "~/modules/error/ThrowError/ThrowAndReportErrorHelper";
import { ContextManager, ContextInstance } from "~/modules/contextManager/ContextManager";
import { FeaturesServiceImpl } from "~/backend/generated/Features/api/features.service";

const metadata = {
    module: "config",
    eventSource: "FeaturesProviderImpl.ts"
};

export const featuresProviderImpl =
    (ctx: ContextManager) =>
    async (sessionToken: string, uiVersion?: string): Promise<FeaturesConfig> => {
        const featuresService = ctx.retrieveInstanceOf(ContextInstance.FeaturesServiceImpl, FeaturesServiceImpl);
        const throwAndReportError = throwAndReportFlexSdkError(ctx);

        let featuresData: FeaturesConfig;

        try {
            featuresData = await featuresService.fetchFeatures({
                token: sessionToken,
                
                ...(uiVersion && { headers: { "X-Flex-Version": uiVersion } })
            });
        } catch (err) {
            const message = `Failed to fetch features: ${err}`;
            const errorCode = err.code || ErrorCode.Unknown;
            return throwAndReportError(
                errorCode,
                { ...metadata, severity: ErrorSeverity.Error },
                message
            ) as unknown as Promise<never>;
        }
        return featuresData;
    };
